<script setup lang="ts">
const { enabled } = usePreviewMode()
const router = useRouter()
const actions = ref([
  {
    label: 'Exit draft mode',
    onClick: exitDraftMode,
    variant: 'soft',
    size: 'sm',
    // removes the ?preview=true from the url
    to: router.currentRoute.value.fullPath.replace('?preview=true', '')
  }
])

async function exitDraftMode() {
  enabled.value = false
  await refreshNuxtData()
}
</script>

<template>
  <UBanner
    v-if="enabled"
    title="You are using the draft mode"
    :actions="actions"
  />
</template>